<script setup>
import axios from "axios";
import { getIpAPI, getExchangeRateAPI } from "@/apis/user"
import { useCartStore } from '@/stores/cartStore'
import { useUserStore } from '@/stores/userStore'
import { areaCodeAPI } from '@/apis/user'
import { ref, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
const i18n = useI18n()
const cartStore = useCartStore()
const userStore = useUserStore()

const lang = ref()

const timer = ref(null);
const zhi = ref('');

const langList = [
    { id: 1, name: "中文", code: "ZN", title: '中国' },
    { id: 2, name: "English", code: "en_US", title: '美国' },
    { id: 3, name: "España", code: "ESP", title: '西班牙语' },
    { id: 4, name: "Português", code: "PCP", title: '葡萄牙语' },
    { id: 5, name: "Nederlands", code: "NED", title: '荷兰语' },
    { id: 6, name: "Polski", code: "PL", title: '波兰语' },
    { id: 7, name: "Deutsch", code: "DE", title: '德语' },
    { id: 8, name: "Français", code: "PCF", title: '法语' },
    { id: 9, name: "Italiano", code: "Ita", title: '意大利语' },
]
/**
 *语言
 * @param {} type 
 * @returns 
 */
const langStatus=(type)=>{
    const stateMap = {
        'ZN': '中文',
        'en_US': 'English',
        'ESP': 'España',
        'PCP': 'Português',
        "NED":"Nederlands", 
        "PL":"Polski",
        "DE": "Deutsch",
        "PCF":"Français", 
        "Ita":"Italiano", 
    }
    return stateMap[type]
}
const currency = ref()
const getExchangeRate = async () => {

    const res = await getExchangeRateAPI()
    if (res.code == 0) {
        CurrencyAll.value = res.data.data;
        userStore.CurrencyAll = res.data.data;
        localStorage.setItem('CurrencyAll', JSON.stringify(CurrencyAll.value))
        userStore.Currency = res.data.data.filter(rate => rate.symbol !== "￥");
        const Currencycheck = localStorage.getItem('CurrencyLANGUAGE')
        if (Currencycheck) {
            currency.value = Currencycheck
            userStore.exchangeRate = CurrencyAll.value.find(rate => rate.currency === Currencycheck);

        } else {
            userStore.exchangeRate = CurrencyAll.value.find(rate => rate.symbol === "￥");
            currency.value = userStore.exchangeRate.currency
            console.log('userStore.exchangeRate.currency',userStore.exchangeRate.currency)

        }
        localStorage.setItem('CurrencyLANGUAGE', currency.value );

    } else {
        ElMessage({ type: 'error', message: res.message })
    }
}
const CurrencyAll = ref()
const getIp = async () => {
    const res = await getIpAPI()
    if (res.code == 0) {
        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        console.log('shiqu', timeZone)
        // console.log('ip:',res.data.ip)
        userStore.ipTime = timeZone
        userStore.userIp = res.data.ip
        localStorage.setItem('countryCode', res.data.countryCode);
        // fetchIPInfo(res.data.ip)
        const countryCode = localStorage.getItem('countryCode')
        if (countryCode) {
            setLang(res.data.countryCode)
        }

    }

}

//根据ip判断显示那种语言
const setLang = (code) => {
    if (code == 'ARG' || code == 'COL' || code == 'MEX' || code == 'ESP' || code == 'CHL') {//西班牙
        localStorage.setItem('language', 'ESP');
        i18n.locale.value = 'ESP'
        lang.value = 'ESP'
        zhi.value = 'ESP'
    } else if (code == 'BR') {//葡萄牙语
        localStorage.setItem('language', 'PCP');
        i18n.locale.value = 'PCP'
        lang.value = 'PCP'
        zhi.value = 'PCP'
    } else if (code == 'BEL' || code == 'NL') {//荷兰
        localStorage.setItem('language', 'NED');
        i18n.locale.value = 'NED'
        lang.value = 'NED'
        zhi.value = 'NED'
    } else if (code == 'POL') {//波兰语
        localStorage.setItem('language', 'PL');
        i18n.locale.value = 'PL'
        lang.value = 'PL'
        zhi.value = 'PL'
    } else if (code == 'DE') {//德语
        localStorage.setItem('language', 'DE');
        i18n.locale.value = 'DE'
        lang.value = 'DE'
        zhi.value = 'DE'
    } else if (code == 'FRA') {//法语
        localStorage.setItem('language', 'PCF');
        i18n.locale.value = 'PCF'
        lang.value = 'PCF'
        zhi.value = 'PCF'
    } else if (code == 'ITA') {//意大利
        localStorage.setItem('language', 'Ita');
        i18n.locale.value = 'Ita'
        lang.value = 'Ita'
        zhi.value = 'Ita'
    } else if (code == 'CHN' || code == 'HK') {
        localStorage.setItem('language', 'ZN');
        i18n.locale.value = 'ZN'
        lang.value = 'ZN'
        zhi.value = 'ZN'
    } else {
        localStorage.setItem('language', 'en_US');
        i18n.locale.value = 'en_US'
        lang.value = 'en_US'
        zhi.value = 'en_US'
    }
}

onMounted(() => {

    const code = localStorage.getItem('countryCode')
    console.log(code)
    if (code) {
        // setLang(code)
        zhi.value = localStorage.getItem('language')
        lang.value = localStorage.getItem('language')
    } else {
        getIp();
    }
    // const all=localStorage.getItem('CurrencyAll')
    // if(all){
    // const Currency = JSON.parse(all);

    // CurrencyAll.value=Currency;
    // userStore.Currency=Currency.filter(rate => rate.symbol !== "￥");
    // currency.value=userStore.exchangeRate.currency
    // userStore.exchangeRate = CurrencyAll.value.find(rate => rate.symbol === "￥");
    // currency.value=userStore.exchangeRate.currency
    // }else{

    // }
    // getExchangeRate()
    // if(userStore.userInfo.token){
    getExchangeRate()
    // 组件挂载后设置定时器
    timer.value = setInterval(getExchangeRate, 20000);
    // }
});
onBeforeUnmount(() => {
    // 组件卸载前清除定时器
    if (timer.value) {
        clearInterval(timer.value);
    }
});
/**
 * 
 * @param code 切换语言
 */
const checkLang = (code) => {
    zhi.value = code
    lang.value = code
    localStorage.setItem('language', code);
    i18n.locale.value = code
    window.location.reload();
}
const checkCurrency = (item) => {

    localStorage.setItem('CurrencyLANGUAGE', item.currency);
    currency.value = item.currency
    userStore.exchangeRate = item
    window.location.reload();
}
</script>

<template>

    <div class="cart">
        <a class="curr" href="javascript:;">
            <svg-icon icon-class="language" class="diqiu" />
            <span>{{langStatus(zhi)  }}</span>
        </a>
        <div class="layer">
            <div class="layerTitle">Language</div>
            <div class="list">
                <div v-for="(item, i) in langList" :key="i">
                    <div :class="item.code == lang ? 'checkitem' : 'item'" @click="checkLang(item.code)">{{ item.name }}
                    </div>

                </div>
            </div>
            <div class="layerTitle">Currency</div>
            <div class="list">
                <div v-for="(item, i) in CurrencyAll" :key="i">
                    <div :class="item.currency == currency ? 'checkitem' : 'item'" @click="checkCurrency(item)">{{
                        item.currency }}
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.cart {
    width: auto;
    position: relative;
    z-index: 600;

    .curr {
        height: 32px;
        line-height: 32px;
        text-align: center;
        position: relative;
        display: block;
        display: flex;
        align-items: center;

        span {
            margin-left: 8px;
        }

        .diqiu {
            height: 28px !important;
            width: 28px !important;
        }

    }

    &:hover {
        .layer {
            opacity: 1;
            transform: none;
        }
    }

    .layer {
        opacity: 0;
        transition: all 0.4s 0.2s;
        transform: translateY(-200px) scale(1, 0);
        width: 240px;
        position: absolute;
        top: 50px;
        right: 0;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
        background: #fff;
        border-radius: 4px;
        // padding-top: 10px;
        padding: 0px 20px 30px 20px;

        .layerTitle {
            // padding: 5px 10px;
            font-family: MicrosoftYaHei;
            font-size: 14px;
            color: #1F1F1F;
            line-height: 14px;
            text-align: left;
            font-style: normal;
            padding: 20px 0;
        }

        &::before {
            content: "";
            position: absolute;
            right: 37px;
            top: -10px;
            width: 20px;
            height: 20px;
            background: #fff;
            transform: scale(0.6, 1) rotate(45deg);
            box-shadow: -3px -3px 5px rgba(0, 0, 0, 0.1);
        }


    }

    .list {

        // padding: 5px 10px;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;

        .item {
            width: 96px;
            height: 28px;
            background: #F3F6F8;
            border-radius: 4px;

            // font-size: 12px;
            // text-align: center;
            // line-height: 24px;
            // white-space: nowrap;
            // cursor: pointer;
            // background: #fff;
            // border: 1px solid #dcdfe6;
            margin-bottom: 10px;
            font-family: MicrosoftYaHei;
            font-size: 12px;
            color: #11192D;
            line-height: 28px;
            text-align: center;
            font-style: normal;

            &:hover {
                width: 96px;
                height: 28px;
                border-radius: 4px;
                background: #FFF1EB;
                font-family: MicrosoftYaHei;
                font-size: 12px;
                color: #FC3938;
                line-height: 28px;
                text-align: center;
                font-style: normal;
                // color: #79bafd;
                // background-color: #79bafd40;
            }
        }



        .checkitem {
            // border: 1px solid #dcdfe6;
            width: 96px;
            height: 28px;
            border-radius: 4px;
            background: #FFF1EB;
            font-family: MicrosoftYaHei;
            font-size: 12px;
            color: #FC3938;
            line-height: 14px;
            text-align: left;
            font-style: normal;
            text-align: center;
            line-height: 28px;
            white-space: nowrap;
            cursor: pointer;
            // margin-bottom: 10px;
        }
    }
}

/* 响应式设计 */
@media (max-width: 768px) {


    .cart {
        width: 100%;

        .curr {
            height: 32px;
            line-height: 32px;
            text-align: center;
            position: relative;
            display: block;
            display: flex;
            align-items: center;
justify-content: flex-end;
            span {
                margin-left: 6px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 12px;
                color: #333333;
                line-height: 17px;
                text-align: left;
                font-style: normal;
            }

            .diqiu {
                height: 18px !important;
                width: 18px !important;
            }
        }

        &:hover {
            .layer {
                opacity: 1;
                transform: none;
            }
        }

        .layer {
            opacity: 0;
            transition: all 0.4s 0.2s;
            transform: translateY(-200px) scale(1, 0);
            width: 240px;
            position: absolute;
            top: 50px;
            right: 0px;
            box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
            background: #fff;
            // background: #f0f;
            border-radius: 4px;
            padding-top: 10px;

            &::before {
                content: "";
                position: absolute;
                right: 0;
                top: -10px;
                width: 20px;
                height: 20px;
                background: #fff;
                transform: scale(0.6, 1) rotate(45deg);
                box-shadow: -3px -3px 5px rgba(0, 0, 0, 0.1);
            }


        }

        .list {
            width: 100%;
            padding: 5px 10px;
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: space-between;

            .item,
            .checkitem {
                width: 85px;
                height: 26px;
                font-size: 12px;
                text-align: center;
                line-height: 24px;
                white-space: nowrap;
                cursor: pointer;
                background: #fff;
                border: 1px solid #dcdfe6;
                margin-bottom: 10px;

                &:hover {
                    width: 85px;
                    border-color: #79bafd;
                    color: #79bafd;
                    background-color: #79bafd40;
                }
            }



            .checkitem {
                border: 1px solid #dcdfe6;
                border-color: #79bafd;
                color: #79bafd;
                background-color: #79bafd40;
                width: 85px;
                height: 26px;
                font-size: 12px;
                text-align: center;
                line-height: 24px;
                white-space: nowrap;
                cursor: pointer;
                margin-bottom: 10px;
            }
         
        }
    }
}
</style>